/**
 * Service to fetch Google Maps API key from backend (AWS Secrets Manager).
 * Used when REACT_APP_GOOGLE_MAPS_API_KEY is not set (e.g. production).
 */
import axios from 'axios';
import { baseApi } from '../API/api';

let cachedKey = null;

/**
 * Fetch Google Maps API key from backend (GoogleMapsAPI secret, MapsKey).
 * Uses short-lived cache to avoid repeated requests.
 * @returns {Promise<string>} The API key or empty string on failure
 */
export async function fetchGoogleMapsApiKey() {
  if (cachedKey) return cachedKey;

  try {
    const response = await axios.get(`${baseApi}/api/secrets/google-maps-key`, {
      timeout: 8000,
    });
    if (response.data?.success && response.data?.key) {
      cachedKey = response.data.key;
      return cachedKey;
    }
  } catch (err) {
    console.warn('Failed to fetch Google Maps API key from backend:', err?.message);
  }
  return '';
}

/** Clear cache (e.g. for testing) */
export function clearGoogleMapsKeyCache() {
  cachedKey = null;
}
